// src/utils/pageUtils.ts
// import http, { apiUrl } from "@/api/http";

// type Lang = "fr" | "en";

// const codeToSlug: Record<string, { fr: string; en: string }> = {
//   home:      { fr: "accueil",   en: "home" },
//   about:     { fr: "a-propos",  en: "about" },
//   portfolio: { fr: "portfolio", en: "portfolio" },
//   contact:   { fr: "contact",   en: "contact" },
// };

// type PageIdResponse =
//   | { page_id: number }
//   | { id: number }
//   | number;

// export async function fetchPageIdByCode(
//   code: string = "home",
//   langue: Lang = "fr"
// ): Promise<number> {
//   const lc = String(code || "").toLowerCase();
//   const l: Lang = langue === "en" ? "en" : "fr";

//   const entry = codeToSlug[lc];
//   if (!entry) throw new Error(`Code de page inconnu: "${code}"`);

//   const slug = entry[l];
//   const url = `${apiUrl("page-id-by-slug")}?langue=${l}&slug=${encodeURIComponent(slug)}`;

//   const { data } = await http.get<PageIdResponse>(url);
//   if (typeof data === "number") return data;
//   if ("page_id" in data && typeof data.page_id === "number") return data.page_id;
//   if ("id" in data && typeof data.id === "number") return data.id;

//   throw new Error("Réponse inattendue de /page-id-by-slug");
// }

import http from "@/api/http";

type Lang = "fr" | "en";

const codeToSlug: Record<string, { fr: string; en: string }> = {
  home:      { fr: "accueil",   en: "home" },
  about:     { fr: "a-propos",  en: "about" },
  portfolio: { fr: "portfolio", en: "portfolio" },
  contact:   { fr: "contact",   en: "contact" },
};

type PageIdResponse = {
  page_id?: number;
  id?: number;
};

/**
 * Récupère l'ID d'une page à partir de son code interne (ex: 'home')
 */
export async function fetchPageIdByCode(
  code: string = "home",
  langue: Lang = "fr"
): Promise<number> {
  const lc = String(code || "").toLowerCase();
  const l: Lang = langue === "en" ? "en" : "fr";

  const entry = codeToSlug[lc];
  if (!entry) throw new Error(`Code de page inconnu: "${code}"`);

  const slug = entry[l];

  // CORRECT : On passe seulement le endpoint. 
  // Axios fera : baseURL ("/api") + endpoint ("page-id-by-slug")
  const { data } = await http.get<PageIdResponse | number>("page-id-by-slug", {
    params: {
      langue: l,
      slug: slug
    }
  });

  // Gestion robuste de la réponse
  if (typeof data === "number") return data;
  if (data && typeof data === "object") {
    if (data.page_id !== undefined) return data.page_id;
    if (data.id !== undefined) return data.id;
  }

  throw new Error(`Impossible de récupérer l'ID pour le slug: ${slug}`);
}